import React, { useEffect } from 'react';
import { useAssessment } from '../context/AssessmentContext';
import WelcomeScreen from './assessment/WelcomeScreen';
import LevelAQuestions from './assessment/LevelAQuestions';
import ModuleSelection from './assessment/ModuleSelection';
import ModuleQuestions from './assessment/ModuleQuestions';
import AssessmentResults from './assessment/AssessmentResults';
import styles from '../styles/assessmentFlow.module.css';

const AssessmentFlow: React.FC = () => {
  const { state, dispatch } = useAssessment();

  useEffect(() => {
    // Initialize assessment when component mounts
    dispatch({ type: 'INITIALIZE_ASSESSMENT' });
  }, [dispatch]);

  const renderCurrentStep = () => {
    switch (state.currentStep) {
      case 'welcome':
        return <WelcomeScreen />;
      case 'levelA':
        return <LevelAQuestions />;
      case 'modules':
        return <ModuleSelection />;
      case 'questions':
        return <ModuleQuestions />;
      case 'results':
        return <AssessmentResults />;
      default:
        return <WelcomeScreen />;
    }
  };

  return (
    <div className={styles.assessmentFlow}>
      <div className={styles.container}>
        {renderCurrentStep()}
      </div>
    </div>
  );
};

export default AssessmentFlow;
